/** @jsx jsx */

import { jsx, render, SelectionSet, Field, Variable, Mutation, IdScalar } from "graphql-jsx";
import { clients } from "utils/clients";
import { UuidScalar } from "GraphQL/Scalars";

type Option = Readonly<{
  uuid: string;
  artistId: string;
}>;

export const UpdateTrackArtistRelation = async (option: Option) => {
  const $uuid = <Variable name="uuid" scalar={<UuidScalar />} value={option.uuid} />;
  const $artistId = <Variable name="id" scalar={<IdScalar />} value={option.artistId} />;
  const { query, variables } = render(
    <Mutation operationName="UPDATE_TRACK_ARTIST_RELATION">
      <SelectionSet
        name="updateMetadata_artist_relation"
        alias="updateArtistRelation"
        argument={{
          where: {
            id: $uuid
          },
          data: {
            artist: {
              connect: {
                artist_id: $artistId
              }
            }
          }
        }}
      >
        <Field name="id" />
      </SelectionSet>
    </Mutation>
  );
  type Data = Readonly<{
    updateArtistRelation: Readonly<{
      id: string;
    }>[];
  }>;
  return await clients.artist.request<Data>(query, variables);
};
